module.exports = __webpack_public_path__ + "img/vinilo-gris.a8420b91.svg";